import { render, staticRenderFns } from "./cms-button.vue?vue&type=template&id=9a4efd5c&scoped=true&"
import script from "./cms-button.vue?vue&type=script&lang=js&"
export * from "./cms-button.vue?vue&type=script&lang=js&"
import style0 from "./cms-button.vue?vue&type=style&index=0&id=9a4efd5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4efd5c",
  null
  
)

export default component.exports